import firebaseSrv from '@/services/firebaseSrv.js'
import _ from 'lodash/core'

// import firebaseSrv from '@/services/firebaseSrv.js'
// import router from '@/router.js'

export const namespaced = true

export const state = {
  users: [],
  entrands: []
}
export const mutations = {
  ALL_USERS(state, users) {
    state.users = users
  },
  ALL_ENTRANTS(state, entrants) {
    state.entrands = entrants
  }
}
export const getters = {
  registrations: state => {
    let usersArray = _.values(state.users)
    return usersArray
  },
  registrationsCount: (state, getters) => {
    return getters.registrations.length
  },
  entrantsCount: (state, getters) => {
    const entrants = getters.registrations.filter(
      registration => registration.entriesStarted > 0
    )
    return entrants.length
  },
  entrantsWithPhotosCount: (state, getters) => {
    const entrants = getters.registrations.filter(
      registration => registration.photosUploaded > 0
    )
    return entrants.length
  },
  entrantsCompletedEntryCount: (state, getters) => {
    const entrants = getters.registrations.filter(
      registration => registration.entriesCompleted > 0
    )
    return entrants.length
  },
  startedEntriesCount: (state, getters) => {
    let count = 0
    getters.registrations.forEach(registration => {
      count = registration.entriesStarted
        ? count + registration.entriesStarted
        : count
    })
    return count
  },
  completedEntriesCount: (state, getters) => {
    let count = 0
    getters.registrations.forEach(registration => {
      count = registration.entriesCompleted
        ? count + registration.entriesCompleted
        : count
    })
    return count
  },
  photosUploadedCount: (state, getters) => {
    let count = 0
    getters.registrations.forEach(registration => {
      count = registration.photosUploaded
        ? count + registration.photosUploaded
        : count
    })
    return count
  }
}
export const actions = {
  getUsers({ commit }) {
    return firebaseSrv
      .readUsers()
      .then(users => commit('ALL_USERS', users.data))
  },
  getEntrants({ commit }) {
    return firebaseSrv
      .readEntrants()
      .then(entrants => commit('ALL_ENTRANTS', entrants.data))
  }
}
